import {connect} from "react-redux";
import ItineraryList from "../components/ItineraryList";
import {removePlace, updatePath, getSuggestions, clearSuggestions, changeProfile} from "../actions";

const mapStateToProps = state => ({
    itinerary: state.itinerary,
    suggestionList: state.suggestionList,
    profile: state.profile
});

const mapDispatchToProps = dispatch => ({
    removePlace: place => dispatch(removePlace(place)),
    updatePath: (places, profile) => dispatch(updatePath(places, profile)),
    getSuggestions: input => dispatch(getSuggestions(input)),
    clearSuggestions: () => dispatch(clearSuggestions()),
    changeProfile: profile => dispatch(changeProfile(profile))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ItineraryList)
